import ListingEnergyCertificateModal from './ListingEnergyCertificateModal';

export default ListingEnergyCertificateModal;
